export const getCurrentTime = (): number => new Date().getTime() / 1000;
